import { render } from "./DinoDash.vue?vue&type=template&id=0119572d&scoped=true"
import script from "./DinoDash.vue?vue&type=script&lang=js"
export * from "./DinoDash.vue?vue&type=script&lang=js"

import "./DinoDash.vue?vue&type=style&index=0&id=0119572d&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/AeAAppDev/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0119572d"]])

export default __exports__